import classnames from 'classnames';
import React from 'react';
import { Table } from 'semantic-ui-react';
import styled from 'styled-components';

import { SubscriptionRequestWarnings } from '@/types/subscriptions/request';
import { User } from '@/types/user';
import { getFullName } from '@/utils/name';
import { UserWarning } from './UserWarning';

type Props = {
  users: User[];
  warnings?: SubscriptionRequestWarnings | null;
};

export const UsersPreview: React.FC<Props> = ({ users, warnings = null }) => {
  return (
    <Styled>
      <Table>
        {users.map((user, i) => {
          const userWarnings =
            warnings && warnings.users && warnings.users[i]
              ? warnings.users[i]
              : null;

          return (
            <Table.Body
              key={i}
              className={classnames('field', {
                'is-warning': userWarnings,
              })}
            >
              <Table.Row className="row">
                <Table.Cell className="name" data-test={`confirm-user-${i}-fn`}>
                  {getFullName(user.firstName, user.lastName)}
                </Table.Cell>
                <Table.Cell
                  className="kana-name"
                  data-test={`confirm-user-${i}-kfn`}
                >
                  {getFullName(user.kanaFirstName, user.kanaLastName)}
                </Table.Cell>
                <Table.Cell
                  className="email"
                  data-test={`confirm-user-${i}-email`}
                >
                  {user.email}
                </Table.Cell>
              </Table.Row>
              {userWarnings && (
                <Table.Row>
                  <Table.Cell colSpan="3" className="warning-message">
                    <UserWarning {...{ userWarnings }} />
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          );
        })}
      </Table>
    </Styled>
  );
};

const Styled = styled.div`
  margin-bottom: 4em;

  .row {
    font-size: 14px;
  }

  .ui.table thead th {
    text-align: center !important;
  }

  .ui.table td {
    padding: 0.5em 0.78571429em !important;
  }

  .ui.table td.upgraded {
    padding-top: 0 !important;
    border-top: none !important;
    font-size: 12px;
  }

  .ui.table td.warning-message {
    padding-top: 0 !important;
    border-top: none !important;

    li {
      font-size: 12px;
    }
  }

  .is-warning {
    background-color: floralwhite;

    .row {
      color: #8b4513 !important;
    }

    .user-preview-cell {
      color: saddlebrown;
    }
  }
`;
